// monitorEvents(window, ['lb-dealeasy-add-to-cart'])

console.log('Dealeasy add to cart event listener added!');

window.addEventListener('lb-dealeasy-add-to-cart', function (e) {
    console.log('Dealeasy add to cart event fired!');
    console.log(e.detail);
    const cartBtn = document.querySelectorAll("#cart-icon-bubble")?.[0];
    if (cartBtn) {
        cartBtn.click()
    }
});

// Create a button and attach it to top of the page and trigger the event for testing
// var button = document.createElement('button');
// button.textContent = 'Vipin';
// button.addEventListener('click', function () {
//     var event = new CustomEvent('lb-dealeasy-add-to-cart', {
//         detail: {
//             productId: '123',
//             productName: 'Product 123',
//             price: 123
//         }
//     });
//     window.dispatchEvent(event);
// });
// document.body.appendChild(button);
